<style scoped>
.prev {
  position: absolute;
  top: 40px;
  left: 20px;
  z-index: 100;
}
.next {
  position: absolute;
  top: 40px;
  right: 30px;
  z-index: 100;
}
</style>
<template>
  <div class="airwaybill" style="">
    <v-btn 
      color="blue-grey"
      class="white--text prev"
      v-on:click="prev(documentId)"
    >
      <v-icon right dark >chevron_left</v-icon> 
      Prev
    </v-btn>
    <v-btn 
      color="blue-grey next"
      class="white--text"
      v-on:click="next(documentId)"
    >
      Next 
      <v-icon right dark >chevron_right</v-icon>
    </v-btn>
    <template>
      <v-tabs
      :centered="true"
      color="white"
      light
      icons-and-text
      :show-arrows="false"
      v-model="config.tab"
      >
      <v-tabs-slider color="green"></v-tabs-slider>
      <v-tab :key="'mawb'" href="#master-awb" ripple>
        Master Air Waybill
      </v-tab>
      <v-tab :key="'hawb'" href="#house-awb" v-on:click="mEnableHAWBLoad()" ripple>
        House Air Waybills ({{ hawbs.length }})
      </v-tab>

      <v-tab-item value="master-awb">
        <v-card flat v-if="loadingMAWB">
           <div class="text-xs-center">
             Loading MAWB .........
           </div>
        </v-card>
        <v-card flat v-else>
          <v-card-text>
            <mawb :key="'mawb'" :email="email" v-if="mawbDocumentLoaded && mawb && typeof mawb.id != 'undefined'" />
            <div class="text-xs-center" v-if="mawbDocumentLoaded && !mawb"><span>No MAWB Found</span></div>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item value="house-awb">
        <v-card flat v-if="loadingHAWB">
           <div class="text-xs-center">
             Loading HAWB .........
           </div>
        </v-card>
        <v-card flat v-else>
          <hawb :key="'hawb'" :email="email" v-if="hawbDocumentLoaded && canLoadHAWB" />
          <div class="text-xs-center" v-else><span v-if="mawbDocumentLoaded">No HAWB Found</span></div>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </template>
</div>
</template>


<script>
import DomainService from "@/services/domain.service";
const MAWB = () => import('@/components/charts/form/awb/mawb.vue');
const HAWB = () => import('@/components/charts/form/awb/hawb.vue');


import {createNamespacedHelpers} from 'vuex';
const {mapState, mapActions, mapGetters, mapMutations} = createNamespacedHelpers('charts');


import awb from '@/store/modules/awb';
const awbNamespace = createNamespacedHelpers('awb');

let hostname = window.location.hostname;
export default {
  props:['awb-form-chart', 'chart'],
  data: function() {
    return {
      dataSource: null,
      id: null,
      timeout: null,
      loadHAWB: false,
      hawbLoaded: false,
      email: DomainService.getAWBEmail(hostname),
    };
  },
  components: {
    'mawb': MAWB,
    'hawb': HAWB
  },
  computed: {
    ...awbNamespace.mapState({
      config: state => state.config,
      form: state => state.mawb,
      mawb: state => state.mawb,
      canLoadHAWB: state => state.canLoadHAWB,
      hawbs: state => state.hawbs,
      showForm: state => state.showForm,
      mawbDocumentImage: state => state.mawbDocumentImage,
      loadingMAWB: state => state.loadingMAWB,
      loadingHAWB: state => state.loadingHAWB,
      mawbDocumentLoaded: state => state.mawbDocumentLoaded,
      hawbDocumentLoaded: state => state.hawbDocumentLoaded,
      documentId: state => state.documentId,
      
    }),
    ...mapState(['parameterisedFilterObject'])
  },
  methods: {
    ...awbNamespace.mapMutations(['mInit', 'mSetDocumentId', 'mSetTab', 'mEnableHAWBLoad']),
    ...awbNamespace.mapActions(['aInit', 'loadMAWB', 'loadHAWBs']),
    rendered: function() {

    },
    next: async function(id) {
      if(typeof this.chart.next != "undefined") {
        const nextId = await this.chart.next(id);
        this.mSetTab('master-awb');
         await this.aInit(nextId);
      }
       
    },
    prev: async function(id) {
      if(typeof this.chart.prev != "undefined") {
        console.log("id......", id);
        const prevId = await this.chart.prev(id);
        this.mSetTab('master-awb');
        await this.aInit(prevId);
      }

    },
    onResize: function() {

    }
  },
  mounted: async function() {

    // this.dataSource = createDataSource({});
    // this.dataSource

    // console.log("$store.state['awb']", this.$store.state['awb']);

    this.mSetTab('master-awb');

    this.id = 'tab' + new Date().toLocaleTimeString();
    this.timeout = setTimeout(function(){
                window.dispatchEvent(new Event('resize'));
              }, 50);

    let id =  typeof this.$route.params.id != 'undefined' ? this.$route.params.id : null;
    id =  typeof this.parameterisedFilterObject.id != 'undefined' ? this.parameterisedFilterObject.id : 3753;

    console.log("this.chart", this.chart);

    try {
      await this.aInit(id);
    } catch(err) {
      console.log("init error", err);
    }
  //  console.log("main chart mounted", this.parameterisedFilterObject);
    // console.log("here mawbDocumentLoaded", this.mawbDocumentLoaded);






  },
  destroyed() {
    clearTimeout(this.timeout);
  },
  beforeCreate: function() {
    if(typeof this.$store.state['awb'] == 'undefined') {
      this.$store.registerModule('awb', awb);
      
    }
  }
}

</script>
